// import HelloWorldVue from "@/components/HelloWorld.vue";
import ClientRegistView from "@/views/ClientRegist.vue";
import { createRouter, createWebHistory } from "vue-router";
import ClientLoginVue from "@/views/ClientLogin.vue";
import ClientHomeVue from "@/views/ClientHome.vue";
import ClientDetailListVue from "@/views/ClientDetailList.vue";
import ClientDetailVue from "@/views/ClientDetail.vue";

const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: "/",
      name: "clientLogin",
      component: ClientLoginVue,
    },
    {
      path: "/client_home",
      name: "clientHome",
      component: ClientHomeVue,
    },
    {
      path: "/client_regist/:SEQ_NO",
      name: "clientUpdate",
      component: ClientRegistView,
    },
    {
      path: "/client_regist/",
      name: "clientRegist",
      component: ClientRegistView,
    },
    {
      path: "/client_detailList",
      name: "clientDetailList",
      component: ClientDetailListVue,
    },
    {
      path: "/client_detail/:SEQ_NO",
      name: "clientDetail",
      component: ClientDetailVue,
    },
  ],
});

export default router;
